import React, {Component} from 'react';

import './ConditionModalInput.css';

class ConditionModalInputForm extends Component {
  
  state = {
    value : "",
  }

  blankAlertMessage = "컨디션을 입력해주세요";

  createCondition = () => {
    const { blankAlertMessage } = this;
    const { createCondition } = this.props;
    const { value } = this.state;

    if (value.trim() === "") {
      alert(blankAlertMessage);
      return;
    }

    createCondition(value);
    this.setState({
      value : "",
    })
  }

  handleInputChanged = (e) => {
    this.setState({
      value : e.target.value,
    })
  }

  handleCreateCondition = (e) => {
    const { createCondition } = this;
    createCondition();
  }

  handleInputKeyPressed = (e) => {
    if (e.key === "Enter") {
      const { createCondition } = this;
      createCondition();
    }
  }

  render() {

    const { value } = this.state;
    const { handleInputChanged } = this;

    const { toggleCreateCondition } = this.props;
    const { handleCreateCondition } = this;
    const { handleInputKeyPressed } = this;

    return (
      <div className="condition-input-form">
        <input className="condition-text-input input-con" value={value} placeholder="컨디션을 입력해주세요"
          onChange={handleInputChanged}
          onKeyPress={handleInputKeyPressed} />
        <button className="btn btn-success input-con create-btn"
          onClick={handleCreateCondition}>
          생성
        </button>
      </div>
    );
  }
}

export default ConditionModalInputForm;